import React from 'react';
import { Grid } from 'semantic-ui-react';
import LazyCohortVisualisation from './LazyCohortVisualisation';
import CohortVisualisationMenu from '../containers/CohortVisualisationMenu';

const CohortVisualisationRows = ({ code, category, isNew }) => (
  <>
    <Grid.Row>
      <Grid.Column>
        <CohortVisualisationMenu code={code} category={category} includeVisibility={!isNew} />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column>
        <LazyCohortVisualisation code={code} category={category} />
      </Grid.Column>
    </Grid.Row>
  </>
);

export default CohortVisualisationRows;
